import TextField from '@mui/material/TextField';
import { t } from '@lingui/core/macro';
import { useFormContext } from '@/lib/form.ts';
import { useStore } from '@tanstack/react-form';
import { useSuspenseQuery } from '@tanstack/react-query';
import { posQueries } from '@/features/pos/queries.ts';

export const PosCountryField = () => {
  const form = useFormContext();
  const posId = useStore(form.store, (state) => state.values.pos);
  const { data: posList } = useSuspenseQuery(posQueries.list());

  return (
    <TextField
      label={t`Country`}
      size="small"
      fullWidth
      disabled
      value={posList.result.find((pos) => pos.id.toString() === posId)?.country ?? ''}
    />
  );
};
